(function () {
  'use strict';

  function applyDiscount(code, onSuccess) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      try { localStorage.setItem('rive_discount', code); } catch(e) {}
      if (onSuccess) onSuccess();
    })
    .catch(function() { if (onSuccess) onSuccess(); });
  }

  // ---- 1. URGENCY BAR ----
  function initUrgencyBar() {
    if (document.querySelector('.rive-urgency-bar')) return;
    if (sessionStorage.getItem('rive_ub_closed')) return;
    var endTime = parseInt(sessionStorage.getItem('rive_ub_end') || '0', 10);
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + (5 * 3600 + 47 * 60 + 33) * 1000;
      sessionStorage.setItem('rive_ub_end', String(endTime));
    }
    var bar = document.createElement('div');
    bar.className = 'rive-urgency-bar';
    bar.innerHTML =
      '<div class="rive-urgency-bar__inner">' +
      '<span>&#128666; <span class="rive-ub-highlight">ENVÍO GRATIS</span> en todos los pedidos</span>' +
      '<span>⚡ <span class="rive-ub-highlight">-5%</span> con código <span class="rive-ub-highlight">RIVE20</span> &mdash; termina en: ' +
      '<span class="rive-urgency-bar__countdown">' +
      '<span class="rive-ub-cd-num" id="rive-ub-h">00</span>:' +
      '<span class="rive-ub-cd-num" id="rive-ub-m">00</span>:' +
      '<span class="rive-ub-cd-num" id="rive-ub-s">00</span>' +
      '</span></span>' +
      '<span>&#9989; Devolución gratis 30 días</span>' +
      '</div>' +
      '<button class="rive-ub-close" aria-label="Cerrar">&times;</button>';
    var header = document.querySelector('.shopify-section-header-sticky, .section-header, header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header);
    } else {
      document.body.prepend(bar);
    }
    bar.querySelector('.rive-ub-close').addEventListener('click', function () {
      bar.style.transition = 'height .3s, opacity .3s, padding .3s';
      bar.style.overflow = 'hidden';
      bar.style.opacity = '0';
      bar.style.height = bar.offsetHeight + 'px';
      bar.style.padding = '0';
      requestAnimationFrame(function () { bar.style.height = '0'; });
      setTimeout(function () { bar.remove(); }, 350);
      sessionStorage.setItem('rive_ub_closed', '1');
    });
    function tick() {
      var rem = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      var h = Math.floor(rem / 3600), m = Math.floor((rem % 3600) / 60), s = rem % 60;
      var hEl = document.getElementById('rive-ub-h');
      var mEl = document.getElementById('rive-ub-m');
      var sEl = document.getElementById('rive-ub-s');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
      if (rem > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  // ---- 2. SOCIAL PROOF TOASTS (orden aleatorio, sin repetir siempre el mismo) ----
  function initSocialProofToasts() {
    if (document.querySelector('.rive-toast')) return;
    var notifications = [
      { name: 'María G.', city: 'Sevilla', product: 'Vestido Giselle', time: 'hace 2 min', initials: 'MG', color: '#C4956A' },
      { name: 'Laura P.', city: 'Madrid', product: 'Conjunto Lino Off-white', time: 'hace 5 min', initials: 'LP', color: '#8B4A36' },
      { name: 'Sofía R.', city: 'Barcelona', product: 'Velora Vestido Floral', time: 'hace 8 min', initials: 'SR', color: '#3A5C3A' },
      { name: 'Ana M.', city: 'Valencia', product: 'Daniela Conjunto Flecos', time: 'hace 12 min', initials: 'AM', color: '#9E6E43' },
      { name: 'Carmen L.', city: 'Bilbao', product: 'ISADORA Volantes', time: 'hace 15 min', initials: 'CL', color: '#5C3A6B' },
      { name: 'Isabel F.', city: 'Málaga', product: 'Giada Blazer Bordado', time: 'hace 18 min', initials: 'IF', color: '#3A4E5C' },
      { name: 'Patricia S.', city: 'Zaragoza', product: 'Doris Mono Cuello Alto', time: 'hace 22 min', initials: 'PS', color: '#6B5C3A' },
      { name: 'Elena V.', city: 'Murcia', product: 'Saira Vestido Floral', time: 'hace 25 min', initials: 'EV', color: '#4A6B5C' },
      { name: 'Cristina B.', city: 'Alicante', product: 'MARIA Conjunto Lino', time: 'hace 3 min', initials: 'CB', color: '#7A5230' },
      { name: 'Marta D.', city: 'Vigo', product: 'Domenica Vestido Gasa', time: 'hace 9 min', initials: 'MD', color: '#4E5C3A' },
      { name: 'Lucía T.', city: 'Granada', product: 'Zelora Conjunto Dos Piezas', time: 'hace 14 min', initials: 'LT', color: '#5C4A3A' },
      { name: 'Paula N.', city: 'San Sebastián', product: 'Giselle Vestido Largo', time: 'hace 20 min', initials: 'PN', color: '#3A5C50' }
    ];

    function shuffle(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
      }
      return a;
    }

    var queue = shuffle(notifications);
    var idx = 0;

    var toast = document.createElement('div');
    toast.className = 'rive-toast';
    toast.innerHTML =
      '<div class="rive-toast__avatar" id="rive-toast-av"></div>' +
      '<div class="rive-toast__content">' +
      '<div class="rive-toast__name" id="rive-toast-name"></div>' +
      '<div class="rive-toast__action">Acaba de comprar <span class="rive-toast__product" id="rive-toast-product"></span></div>' +
      '<div class="rive-toast__time" id="rive-toast-time"></div>' +
      '</div>' +
      '<button class="rive-toast__close" aria-label="Cerrar">&times;</button>';
    document.body.appendChild(toast);
    toast.querySelector('.rive-toast__close').addEventListener('click', function () {
      toast.classList.remove('rive-toast--show');
    });

    function showNext() {
      if (idx >= queue.length) {
        queue = shuffle(notifications);
        idx = 0;
      }
      var n = queue[idx]; idx++;
      var av = document.getElementById('rive-toast-av');
      var nm = document.getElementById('rive-toast-name');
      var pr = document.getElementById('rive-toast-product');
      var ti = document.getElementById('rive-toast-time');
      if (av) { av.textContent = n.initials; av.style.background = 'linear-gradient(135deg,' + n.color + ',#191917)'; }
      if (nm) nm.textContent = n.name + ' (' + n.city + ')';
      if (pr) pr.textContent = n.product;
      if (ti) ti.textContent = n.time;
      toast.classList.add('rive-toast--show');
      setTimeout(function () { toast.classList.remove('rive-toast--show'); }, 4500);
    }

    var initialDelay = 5000 + Math.floor(Math.random() * 4000);
    setTimeout(function loop() {
      showNext();
      var nextDelay = 45000 + Math.floor(Math.random() * 25000);
      setTimeout(loop, nextDelay);
    }, initialDelay);
  }

  // ---- 3. EXIT INTENT POPUP ----
  function initExitIntent() {
    if (sessionStorage.getItem('rive_exit_shown')) return;
    if (document.querySelector('.rive-exit-overlay')) return;
    var overlay = document.createElement('div');
    overlay.className = 'rive-exit-overlay';
    overlay.innerHTML =
      '<div class="rive-exit-popup">' +
      '<div class="rive-exit-popup__top">' +
      '<button class="rive-exit-popup__close" aria-label="Cerrar">&times;</button>' +
      '<div class="rive-exit-popup__tag">&#x23F3; Oferta exclusiva &middot; Solo para ti</div>' +
      '<div class="rive-exit-popup__title">¡Espera! Antes de que te vayas&hellip;</div>' +
      '<div class="rive-exit-popup__sub">Te aplicamos un <strong>5% de descuento</strong> automáticamente en tu pedido</div>' +
      '</div>' +
      '<div class="rive-exit-popup__bottom">' +
      '<div class="rive-exit-popup__code-wrap">' +
      '<div class="rive-exit-popup__code" id="rive-exit-code">RIVE20</div>' +
      '<div class="rive-exit-popup__code-check" id="rive-exit-check">✓ ¡Descuento aplicado al carrito!</div>' +
      '</div>' +
      '<div class="rive-exit-popup__hint" id="rive-exit-hint">&#128072; Pulsa el botón para aplicarlo automáticamente</div>' +
      '<button class="rive-exit-popup__cta" id="rive-exit-cta">⚡ Aplicar mi 5% y seguir comprando</button>' +
      '<span class="rive-exit-popup__no" id="rive-exit-no">No gracias, prefiero pagar el precio completo</span>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    function close() {
      overlay.classList.remove('rive-exit--active');
      sessionStorage.setItem('rive_exit_shown', '1');
    }
    overlay.querySelector('.rive-exit-popup__close').addEventListener('click', close);
    document.getElementById('rive-exit-no').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    var ctaBtn = document.getElementById('rive-exit-cta');
    var codeEl = document.getElementById('rive-exit-code');
    var checkEl = document.getElementById('rive-exit-check');
    var hintEl = document.getElementById('rive-exit-hint');
    function activateDiscount() {
      ctaBtn.textContent = 'Aplicando…';
      ctaBtn.disabled = true;
      applyDiscount('RIVE20', function () {
        codeEl.style.display = 'none';
        checkEl.style.display = 'block';
        hintEl.style.display = 'none';
        ctaBtn.textContent = '✓ ¡Descuento aplicado! Ir a comprar';
        ctaBtn.disabled = false;
        ctaBtn.style.background = '#2d6a4f';
        ctaBtn.onclick = function() { close(); window.location.href = '/checkout?discount=RIVE20'; };
        sessionStorage.setItem('rive_discount_applied', '1');
      });
    }
    ctaBtn.addEventListener('click', activateDiscount);
    codeEl.addEventListener('click', activateDiscount);
    var triggered = false;
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 20 && !triggered) { triggered = true; overlay.classList.add('rive-exit--active'); }
    });
    setTimeout(function () {
      if (!triggered) { triggered = true; overlay.classList.add('rive-exit--active'); }
    }, 45000);
  }

  // ---- 4. AUTO DISCOUNT ON CART ----
  function initAutoDiscountOnCart() {
    var applied = sessionStorage.getItem('rive_discount_applied');
    if (!applied) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: 'RIVE20' })
    }).catch(function() {});
  }

  // ---- 5. GMAIL BUTTON ----
  function initGmailButton() {
    if (document.querySelector('.rive-gmail')) return;
    var btn = document.createElement('a');
    btn.className = 'rive-gmail';
    btn.href = 'mailto:rivestore03@gmail.com?subject=Consulta%20Rive%20Store&body=Hola%2C%20me%20gustar%C3%ADa%20hacer%20una%20consulta%20sobre%20un%20producto.';
    btn.setAttribute('aria-label', 'Contactar por Email');
    btn.title = 'Contactar con Rive Store';
    btn.innerHTML =
      '<svg viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="27" cy="27" r="27" fill="#C9B097"/>' +
      '<path d="M13 18.5h28a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H13a2 2 0 0 1-2-2v-15a2 2 0 0 1 2-2z" stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M11 19.5l16 11.5 16-11.5" stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="rive-gmail__badge">?</span>';
    document.body.appendChild(btn);
  }

  // ---- 6. PRODUCT PAGE ENHANCEMENTS ----
  function initProductEnhancements() {
    var isProduct = document.querySelector('.product__info-wrapper, product-info, .product-template');
    if (!isProduct) return;
    var priceEl = document.querySelector('.product__info-wrapper .price, .product-form, .product-form__submit');
    if (priceEl && !document.querySelector('.rive-trust-strip')) {
      var strip = document.createElement('div');
      strip.className = 'rive-trust-strip';
      strip.innerHTML =
        '<span class="rive-trust-strip__item" data-icon="&#128666;">Envío gratis en todos los pedidos</span>' +
        '<span class="rive-trust-strip__item" data-icon="&#9989;">Devolución gratis 30 días</span>' +
        '<span class="rive-trust-strip__item" data-icon="&#128274;">Pago 100% seguro</span>' +
        '<span class="rive-trust-strip__item" data-icon="&#128142;">Calidad garantizada</span>';
      priceEl.after ? priceEl.after(strip) : priceEl.parentNode.insertBefore(strip, priceEl.nextSibling);
    }
    var form = document.querySelector('.product-form, form[action*="/cart/add"]');
    if (form && !document.querySelector('.rive-stock-bar')) {
      var stocks = [
        'Solo quedan 3 unidades en tu talla',
        '¡Alta demanda! 12 personas lo están viendo ahora',
        'Últimas 5 unidades disponibles'
      ];
      var stockBar = document.createElement('div');
      stockBar.className = 'rive-stock-bar';
      stockBar.innerHTML = '<span class="rive-stock-bar__dot"></span><span>' +
        stocks[Math.floor(Math.random() * stocks.length)] + '</span>';
      form.before ? form.before(stockBar) : form.parentNode.insertBefore(stockBar, form);
    }
  }

  // ---- 7. BOTÓN COMPRAR AHORA ----
  function initBuyNowButton() {
    if (!document.querySelector('.product__info-wrapper, product-info')) return;
    if (document.querySelector('.rive-buy-now')) return;
    var btnsContainer = document.querySelector('.product-form__buttons');
    if (!btnsContainer) return;
    function getCurrentVariantId() {
      var input = btnsContainer.closest('form') &&
                  btnsContainer.closest('form').querySelector('input[name="id"].product-variant-id');
      if (input && input.value) return input.value;
      var anyInput = document.querySelector('.product-form input[name="id"], input.product-variant-id');
      if (anyInput && anyInput.value) return anyInput.value;
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant') || null;
    }
    function getCurrentQty() {
      var qtyInput = document.querySelector('.quantity__input, input[name="quantity"]');
      return qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    }
    var btn = document.createElement('button');
    btn.className = 'rive-buy-now';
    btn.type = 'button';
    btn.textContent = 'COMPRAR AHORA';
    btn.setAttribute('aria-label', 'Comprar ahora - ir al pago');
    btnsContainer.parentNode.insertBefore(btn, btnsContainer);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = getCurrentVariantId();
      var qty = getCurrentQty();
      if (!variantId) { window.location.href = '/checkout'; return; }
      btn.classList.add('rive-buy-now--loading');
      btn.textContent = 'Procesando…';
      window.location.href = '/cart/' + variantId + ':' + qty + '?storefront=true';
    });
    btn.addEventListener('pointerdown', function () { btn.classList.add('rive-buy-now--pressing'); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function(evt) {
      btn.addEventListener(evt, function () { btn.classList.remove('rive-buy-now--pressing'); });
    });
  }

  // ---- 8. ANNOUNCEMENT BAR TICKER ----
  function initAnnouncementTicker() {
    var msgEl = document.querySelector('.announcement-bar__message span, .announcement-bar__message');
    if (!msgEl) return;
    var messages = [
      '&#128666; Envío gratis en todos los pedidos',
      '⚡ 5% de descuento automático con RIVE20',
      '&#9989; Devolución gratuita 30 días',
      '&#128274; Pago 100% seguro &middot; Visa &middot; PayPal &middot; Bizum',
      '&#127775; Más de 2.400 clientas satisfechas'
    ];
    var i = 0;
    setInterval(function () {
      i = (i + 1) % messages.length;
      msgEl.style.transition = 'opacity .3s';
      msgEl.style.opacity = '0';
      setTimeout(function () { msgEl.innerHTML = messages[i]; msgEl.style.opacity = '1'; }, 320);
    }, 4000);
  }

  // ---- 9. CART ENHANCEMENTS ----
  function initCartEnhancements() {
    var progressText = document.querySelector('.cart-progress__text');
    if (progressText) {
      progressText.textContent = progressText.textContent
        .replace('You\'re', '¡Solo te faltan')
        .replace('away from free shipping', 'para el envío gratis!');
    }
  }

  // ---- INIT ----
  document.addEventListener('DOMContentLoaded', function () {
    initAutoDiscountOnCart();
    initUrgencyBar();
    initSocialProofToasts();
    initExitIntent();
    initGmailButton();
    initProductEnhancements();
    initBuyNowButton();
    initAnnouncementTicker();
    initCartEnhancements();
  });

})();
